import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {PaymentCardReaderRepository} from "./impl/service/repository/paymentCardReader.repository";
import {PaymentCardReaderDataService} from "./impl/service/repository/paymentCardReader.dataservice";
import {errorMessages} from "../../../../core/error/errorMessages";

@NgModule({
})
export class PaymentCardReaderModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: PaymentCardReaderRepository,
                dataService: PaymentCardReaderDataService,
    ) {

        entityDataService.registerServices({
            PaymentCardReader: dataService,
        });

        entityServices.registerEntityCollectionServices({
            PaymentCardReader: repository,
        });

        errorMessages.set('SUMUP_CARDREADER_CHECKOUT_OFFLINE', 'Veillez allumer le lecteur de carte');
    }
}
